export const MailIcon = (
  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 0L0 0L0 11.2L14 11.2L14 0ZM12.6 2.8L7 6.3L1.4 2.8L1.4 1.4L7 4.9L12.6 1.4V2.8Z"
      fill="#05050D"
      fillOpacity="0.2"
    />
  </svg>
);
